export type SectionFit = 'full' | 'mid' | 'contained';
/**
@description maps to TW's layer-base custom max-width values in globals.css
 */
export function getWrapperMaxWidth(fit: SectionFit): string {
  if (fit === 'full') {
    return 'max-w-section-full';
  }
  if (fit === 'mid') {
    return 'max-w-section-mid';
  }

  return 'max-w-section-contained';
}
